export default __webpack_public_path__ + "static/EngagementFeaturesBackgroundGradient-cadeed6903649f361502d28b7e357436.png";